import { IsSortable } from "newui/features/Rfx/types/returnable-schedule-question.type";
import { IsRemovable } from "../../../types/Creation/create-rfx-form-types";

type SortableOrRemovable = IsSortable & IsRemovable;

export const sortRemovableAndSortOrderItems = (
	itemsToSort: SortableOrRemovable[]
) => {
	return itemsToSort.sort((a, b) => {
		// First, sort by isRemove
		if (a.isRemove !== b.isRemove) {
			return a.isRemove === 1 ? 1 : -1;
		}
		// Then, sort by sort_order ascending
		return a.sort_order - b.sort_order;
	});
};

const scrollAndFocusOn = (elementId: string): void => {
	setTimeout(() => {
		const cardElement = document.getElementById(elementId);
		cardElement.scrollIntoView({ behavior: "smooth", block: "start" });
		(cardElement.children?.[0]?.children?.[0] as HTMLElement)?.focus();
	}, 200);
};

export const scrollAndFocusOnQuestion = (questionId: number | string): void => {
	scrollAndFocusOn(`question-display-${questionId}`);
};

export const scrollAndFocusOnSection = (sectionId: number | string): void => {
	scrollAndFocusOn(`section-container-${sectionId}`);
};
